import React from 'react';
import { Box, BoxProps } from '@chakra-ui/react';
import { DistanceBetween } from './types';

type DefaultScreenTileBoxProps = BoxProps & {
  distanceBetweenTiles?: DistanceBetween;
};

export const DefaultScreenTileBox: React.FC<DefaultScreenTileBoxProps> = ({
  distanceBetweenTiles: distance = DistanceBetween.none,
  children,
  ...props
}) => {
  return (
    <Box my={distance} {...props}>
      {children}
    </Box>
  );
};
